import { SocraticDialogueFragment } from "@/generated/graphql";

/**
 * The latest moment the student finished a recording anywhere in this session,
 * across every dialogue. This is the anchor the reattempt window is counted
 * from. Returns null when no turn in the session has finished a recording.
 */
export function latestRecordingCompletedAt(
  dialogues: readonly SocraticDialogueFragment[]
): string | null {
  return dialogues
    .flatMap((dialogue) => dialogue.turns)
    .reduce<string | null>((latest, turn) => {
      const completedAt = turn.recordingCompletedAt;
      if (completedAt == null) return latest;
      if (latest == null) return completedAt;
      return new Date(completedAt) > new Date(latest) ? completedAt : latest;
    }, null);
}
